// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';

export const updateSearchQueryString = query => ({
    query,
    type: actions.UPDATE_CLAIM_SEARCH_QUERY_STRING
});



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/search-query-string.js